module.exports = __webpack_public_path__ + "static/media/ico_mail.bb3d27de.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/Drawing/imgs/ico_mail.svg
// module id = 1677
// module chunks = 0